import type { IUserRepository } from '../repositories/IUserRepository.js';
import type { ProjectMembershipEntity } from '../entities/UserEntity.js';

interface Dependencies {
  userRepository: IUserRepository;
}

export function createGetUserProjectMembershipsUseCase({ userRepository }: Dependencies) {
  return async function getUserProjectMemberships(input: {
    profileId: string;
    orgId: string;
  }): Promise<ProjectMembershipEntity[]> {
    return userRepository.getProjectMemberships(input.profileId, input.orgId);
  };
}
